export const DEFAULTFLATWEIGHT = 43;
export const DEFAULTWINDSIM = 144;
